import { isTemporal, NormalizedNil } from '@willow/types-iso';

import { isNotNull } from './isNotNull';

/** Recursively remove null or undefined from any value in an object */
export function normalizeNilValues(object: null | undefined): {};
export function normalizeNilValues<T extends object>(object: T): NormalizedNil<T>;
export function normalizeNilValues<T extends object>(object: T | null | undefined): NormalizedNil<T> | {} {
  if (!object) {
    return {};
  }
  return Object.entries(object)
    .filter(([, value]) => isNotNull(value))
    .reduce((result, [key, value]) => {
      // Date objects get all wonky if passed into normalizeNilValues
      if (value instanceof Object && !(value instanceof Date) && !isTemporal(value)) {
        result[key] = normalizeNilValues(value);
        return result;
      }
      result[key] = value;
      return result;
    }, {} as Record<string, any>) as NormalizedNil<T>;
}
